import React from 'react';
import styles from './index.module.scss';
import clsx from 'clsx';
import { CompanyLogo } from 'components/CompanyLogo';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';

type StepStartProps = {
  className?: string;
  logo?: string;
  onStart: () => void;
};

const StepStart: React.FC<StepStartProps> = (props) => {
  return (
    <div className={clsx(styles.root, props.className)}>
      <CompanyLogo src={props.logo!} responsive={true} />
      <h2>Driver Checklist Form</h2>
      <p>
        The following list will be used by J.B. Hunt Transport, Inc. (Carrier)
        to assist in determining that an employee driver or a contractor
        providing services under the Independent Contractor Operating Agreement
        (as applicable) is qualified to safely operate a commercial motor
        vehicle as required by the Federal Motor Carrier Safety Regulations
        under Part 391.{' '}
      </p>
      <ButtonWithArrowIcon
        onClick={props.onStart}
        variant="contained"
        color="primary"
      >
        Let’s Go
      </ButtonWithArrowIcon>
    </div>
  );
};

export default StepStart;
